import React from 'react';

const InputWraper = (props) => (
    <div className="form-group">
        <div className="md-form">
            <div className="input-icon">
                <div className="input-group-prepend pr-3">
                    <i className={props.icon}></i>
                </div>
                <div className="icon-form-control">
                    {props.children}
                    <label for={props.id} className={props.active == true ? "active": ""}>{props.title}</label>
                    {/* <!-- <label for="materialConsLoc1" className="">Consumer Location</label> --> */}
                </div>
            </div>
        </div>


    </div>
);

// Select.propTypes = {
//   name: React.PropTypes.string.isRequired,
//   options: React.PropTypes.array.isRequired,
//   selectedOption: React.PropTypes.string,
//   controlFunc: React.PropTypes.func.isRequired,
//   placeholder: React.PropTypes.string
// };

export default InputWraper;